var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrcularBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 120,
    viewBox: "0 0 123 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_g_57_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 60C4 29.0721 29.0721 4 60 4H63C93.9279 4 119 29.0721 119 60C119 90.9279 93.9279 116 63 116H60C29.0721 116 4 90.9279 4 60Z",
    fill: "#95D2AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_g_57_113",
    x: 0,
    y: 0,
    width: 123,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.25 0.25",
    numOctaves: 3,
    seed: 8254
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 8,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_57_113"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrcularBg);
export default __webpack_public_path__ + "static/media/crcular-bg.6b7d080524336123bacaf37fe66b701d.svg";
export { ForwardRef as ReactComponent };